import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vilka volymregler gäller för mikrobryggeri vid gårdsförsäljning?";
const SHORT_ANSWER = "Mikrobryggerier omfattas av samma begränsningar per kund och dag, t.ex. upp till 6 liter starköl. Detaljerna fastställs i föreskrifter.";

export const Route = createFileRoute("/fraga/vilka-volymregler-galler-for-mikrobryggeri")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vilka volymregler gäller för mikrobryggeri vid …" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"Endast öl tillverkad i bryggeriet får säljas. Säljvolymen får inte gå utöver vad som rimligen kan konsumeras privat."}
      source={{ label: "Prop. 2025/26:21 – Förenklade regler för serveringstillstånd", href: "https://www.regeringen.se/rattsliga-dokument/proposition/2025/10/prop.-20252621/" }}
      extraSources={[]}
      deepGuide={{ to: "/gardsforsaljning/mikrobryggeri", label: "Gårdsförsäljning – mikrobryggeri" }}
      related={[{"to": "/fraga/nar-trader-gardsforsaljning-i-kraft", "label": "När träder gårdsförsäljningen i kraft?"}, {"to": "/fraga/vad-ar-skillnaden-mot-systembolaget", "label": "Vad skiljer gårdsförsäljning från Systembolaget?"}, {"to": "/fraga/far-vingard-salja-via-natet", "label": "Får en vingård sälja vin via nätet under gårdsförsäljningsreglerna?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vilka volymregler gäller för mikrobryggeri vid gårdsförsä…" },
      { name: "description", content: "Mikrobryggerier omfattas av samma begränsningar per kund och dag, t.ex. upp till 6 liter starköl. Detaljerna fastställs i föreskrifter." },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vilka-volymregler-galler-for-mikrobryggeri" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vilka-volymregler-galler-for-mikrobryggeri" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vilka-volymregler-galler-for-mikrobryggeri",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vilka volymregler gäller för mikrobryggeri vid …", url: "https://alkoholprovet.se/fraga/vilka-volymregler-galler-for-mikrobryggeri" },
      ]),
    ],
  }),
});
